export const GET_CUSTOMERS_LIST = null;
export const SELECTED_CUSTOMER_ID = null;
export const SELECTED_CUSTOMER_ID_FOR_APPOINTMENT_VIEW_DETAILS = null;